import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Cash = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="cash icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={`color-iconBrand-default ${pathClass}`}
      clipRule="evenodd"
      fillRule="evenodd"
      d="M62 13.333A3.333 3.333 0 0 0 58.667 10H5.333A3.333 3.333 0 0 0 2 13.333V40a3.333 3.333 0 0 0 3.333 3.333h53.334A3.333 3.333 0 0 0 62 40V13.333Zm-50.285 0H5.333v6.382a5 5 0 0 0 6.382-6.382Zm3.452 0a8.333 8.333 0 0 1-9.833 9.833v7A8.333 8.333 0 0 1 15.166 40h33.666a8.333 8.333 0 0 1 9.833-9.833v-7a8.333 8.333 0 0 1-9.833-9.833H15.167Zm43.5 0h-6.383a5 5 0 0 0 6.382 6.382v-6.382ZM5.333 40h6.383a5 5 0 0 0-6.382-6.382V40Zm53.334-6.382A5 5 0 0 0 52.285 40h6.382v-6.382Z"
    />
    <path
      className={`color-iconOnInverse-default ${pathClass}`}
      clipRule="evenodd"
      fillRule="evenodd"
      d="M15.333 15c0-.57-.057-1.128-.166-1.667h33.666a8.333 8.333 0 0 0 9.833 9.833v7A8.333 8.333 0 0 0 48.834 40H15.167a8.333 8.333 0 0 0-9.833-9.833v-7a8.333 8.333 0 0 0 10-8.167Z"
    />
    <path
      className={`color-iconOnInverse-default ${pathClass}`}
      d="M11.716 40H5.333v-6.382A5 5 0 0 1 11.715 40ZM57 33.333c.584 0 1.145.1 1.667.285V40h-6.383A5 5 0 0 1 57 33.333ZM52.285 13.333h6.382v6.382a5 5 0 0 1-6.382-6.382ZM5.333 13.333h6.383a5 5 0 0 1-6.382 6.382v-6.382Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      d="M32 18.333c.789 0 1.429.622 1.429 1.39v.536c1.116.303 2.102.966 2.623 1.955a1.37 1.37 0 0 1-.62 1.87c-.702.349-1.563.079-1.923-.604-.12-.226-.619-.633-1.509-.633-.58 0-.99.155-1.221.331-.195.15-.327.355-.327.71 0 .268.061.392.098.449.04.064.114.138.262.22.331.181.748.262 1.302.368l.208.04c.529.103 1.609.313 2.57.841 1.047.577 2.108 1.632 2.108 3.368 0 1.314-.653 2.386-1.621 3.087a5.247 5.247 0 0 1-1.95.85v.5c0 .767-.64 1.389-1.429 1.389s-1.429-.622-1.429-1.389v-.523C28.67 32.62 27 31.23 27 29.174c0-.767.64-1.389 1.429-1.389s1.428.622 1.428 1.39c0 .42.605 1.311 2.143 1.311.744 0 1.32-.198 1.672-.453.324-.235.47-.514.47-.859 0-.424-.188-.692-.658-.95-.532-.293-1.206-.434-1.764-.543l-.158-.03c-.492-.09-1.388-.255-2.154-.675a3.494 3.494 0 0 1-1.282-1.168c-.354-.551-.53-1.199-.53-1.92 0-1.208.534-2.218 1.416-2.892a4.393 4.393 0 0 1 1.56-.747v-.527c0-.767.639-1.389 1.428-1.389Z"
    />
    <path
      className={`color-iconPrimary-disabled ${pathClass}`}
      d="M11.715 40H5.333v-6.382A5 5 0 0 1 11.715 40ZM57 33.333c.584 0 1.145.1 1.667.285V40h-6.383A5 5 0 0 1 57 33.333ZM52.284 13.333h6.383v6.382a5 5 0 0 1-6.382-6.382ZM5.333 13.333h6.382a5 5 0 0 1-6.382 6.382v-6.382Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      clipRule="evenodd"
      fillRule="evenodd"
      d="M7.583 47.535a1.5 1.5 0 0 1 1.5-1.5h45.834a1.5 1.5 0 1 1 0 3H9.083a1.5 1.5 0 0 1-1.5-1.5ZM11.75 53.786a1.5 1.5 0 0 1 1.5-1.5h37.5a1.5 1.5 0 1 1 0 3h-37.5a1.5 1.5 0 0 1-1.5-1.5Z"
    />
  </svg>
)
